const CURRENT_LOCALE_KEY = 'currentLocale';

export { CURRENT_LOCALE_KEY };
